import React from "react";
import EditableTable from "./_EditableTable";

export default function Integration() {
  return (
    <>
      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500 section-eyebrow">Integration &amp; Landscape</div>
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-zinc-900 mt-1">Integration</h2>
        <p className="text-sm text-zinc-500 mt-1 max-w-3xl">Interface inventory · landscape · technical debt register.</p>
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Interface inventory</div>
        <EditableTable
          sectionKey="integration"
          listKey="interfaces"
          testidPrefix="ifc"
          labelSingular="interface"
          columns={[
            { key: "ref", label: "Ref", width: "80px" },
            { key: "name", label: "Interface name" },
            { key: "source", label: "Source", width: "130px" },
            { key: "target", label: "Target", width: "130px" },
            { key: "middleware", label: "Middleware", type: "select", options: ["Direct", "CPI", "SAP PI/PO", "BTP IS", "MuleSoft", "Boomi", "Custom API"], width: "130px" },
            { key: "protocol", label: "Protocol", type: "select", options: ["IDoc", "REST", "SOAP", "OData", "SFTP", "AS2", "gRPC", "Event"], width: "100px" },
            { key: "frequency", label: "Frequency", type: "select", options: ["Real-time", "Near real-time", "Hourly", "Daily", "Weekly", "On-demand"], width: "130px" },
            { key: "criticality", label: "Criticality", type: "select", options: ["Low", "Medium", "High", "Mission-critical"], width: "130px" },
            { key: "status", label: "Status", type: "select", options: ["Planned", "In design", "In build", "In test", "Live"], width: "110px" },
          ]}
          emptyRow={() => ({ ref: "", name: "", source: "", target: "", middleware: "CPI", protocol: "REST", frequency: "Real-time", criticality: "Medium", status: "Planned" })}
        />
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Technical debt / interface risk register</div>
        <EditableTable
          sectionKey="integration"
          listKey="techDebt"
          testidPrefix="td"
          labelSingular="risk"
          columns={[
            { key: "area", label: "Area" },
            { key: "issue", label: "Issue / debt" },
            { key: "severity", label: "Severity", type: "select", options: ["Low", "Medium", "High", "Critical"], width: "110px" },
            { key: "remediation", label: "Remediation plan" },
            { key: "owner", label: "Owner", width: "120px" },
            { key: "targetDate", label: "Target date", type: "date", width: "140px" },
          ]}
          emptyRow={() => ({ area: "", issue: "", severity: "Medium", remediation: "", owner: "", targetDate: "" })}
        />
      </div>
    </>
  );
}
